import React from 'react';
import styled from 'styled-components';


const SubHeader = styled.div`
padding-top:10px;
display:grid;
grid-template-columns:24px  minmax(100px,200px) minmax(100px,360px) 64px 64px 138px 44px
;
padding-left:10px;
padding-right:10px;
padding-bottom:10px;

`;


const Divider = styled.div`
    width:100%;
    height:1px;
    background-color:rgba(0, 0, 0, 0.20000000298023224);
`;

const Divider2 = styled.div`
    width:100%;
    height:1px;
    background-color:rgba(0, 0, 0, 0.20000000298023224);
`;


const SubHeaderText = styled.div`
color: gray;
font-family: Roboto;
font-size: 14px;
font-weight: 500;
line-height: 19px;
text-align: left;
`;

const ProjectProceduresHeader = props => {

    return ( 
            <>
            <Divider/>
            <SubHeader>
                <div/>
                <SubHeaderText>SDN</SubHeaderText>
                <SubHeaderText>Title</SubHeaderText>
                <SubHeaderText>IWPP</SubHeaderText>
                <SubHeaderText>Rev</SubHeaderText>
                <SubHeaderText>Effective Date</SubHeaderText>
                <SubHeaderText>URL</SubHeaderText>
            </SubHeader>
            <Divider2/>
            </>

            
)
}

export default ProjectProceduresHeader;